import { styled } from '@mui/system';


export const DeleteButton = styled('span')(({ theme }) => ({
    color: theme.palette.dangerPrimary.main,
}));